import React from 'react';
import { Container, Card, Alert } from 'react-bootstrap';
import { FaClock } from 'react-icons/fa';

const CoachPendingApproval = () => {
    return (
        <Container className="py-5" dir="rtl">
            <Card className="shadow">
                <Card.Body className="text-center">
                    <div className="mb-4">
                        <FaClock size={64} className="text-warning" />
                    </div>
                    <h2 className="mb-4">הרשמתך לארגון ממתינה לאישור</h2>
                    <Alert variant="info" className="mb-4">
                        <p className="mb-0">
                            הרשמתך נשלחה למנהל הארגון לאישור. ברגע שהמנהל יאשר את הרשמתך, תוכל להתחיל להשתמש במערכת.
                        </p>
                    </Alert>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default CoachPendingApproval; 